// this component was automatically generated by IconGlyph.template.js
import { Suspense, type FunctionComponent } from 'react';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { useFeatureGate } from '@trello/feature-gate-client';
import { useLazyComponent } from '@trello/use-lazy-component';

import { Icon } from '../components/Icon';
import type { Color, GlyphProps } from '../components/Icon/Icon.types';

const AdminChevronIconGlyph = () => {
  return (
    <svg
      width="24"
      height="24"
      role="presentation"
      focusable="false"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7072 6.29289C12.3167 5.90237 11.6835 5.90237 11.293 6.29289L6.70011 10.8858C6.31351 11.2724 6.31351 11.8992 6.70011 12.2858C7.08671 12.6724 7.71351 12.6724 8.10011 12.2858L12.0001 8.38579L15.9001 12.2858C16.2867 12.6724 16.9135 12.6724 17.3001 12.2858C17.6867 11.8992 17.6867 11.2724 17.3001 10.8858L12.7072 6.29289ZM17.3001 15.8858L12.7072 11.2929C12.3167 10.9024 11.6835 10.9024 11.293 11.2929L6.70011 15.8858C6.31351 16.2724 6.31351 16.8992 6.70011 17.2858C7.08671 17.6724 7.71351 17.6724 8.10011 17.2858L12.0001 13.3858L15.9001 17.2858C16.2867 17.6724 16.9135 17.6724 17.3001 17.2858C17.6867 16.8992 17.6867 16.2724 17.3001 15.8858Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const AdminChevronIcon: FunctionComponent<GlyphProps> = (props) => {
  const { testId, dangerous_className, size, color, label, block } = props;
  const { value: isIconFlagEnabled } = useFeatureGate('trello_ads_icons');

  const LazyAdsIcon = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "ADS-AdminChevronIcon" */ '@atlaskit/icon/core/priority-highest'
      ),
    { namedImport: 'default', preload: false },
  );

  const adsIconSize = size === 'medium' || size === 'small' ? size : undefined;

  return isIconFlagEnabled ? (
    <span className={dangerous_className}>
      <ErrorBoundary
        tags={{
          ownershipArea: 'trello-ghost',
          feature: 'ADS Icon',
        }}
      >
        <ChunkLoadErrorBoundary fallback={null}>
          <Suspense fallback={null}>
            <LazyAdsIcon
              label={label || ''}
              testId={testId || 'AdminChevronIcon'}
              color={color as Color}
              size={adsIconSize}
            />
          </Suspense>
        </ChunkLoadErrorBoundary>
      </ErrorBoundary>
    </span>
  ) : (
    <Icon
      testId={testId || 'AdminChevronIcon'}
      size={size}
      dangerous_className={dangerous_className}
      color={color}
      block={block}
      label={label}
      glyph={AdminChevronIconGlyph}
    />
  );
};
